import axios from '@/libs/api.request'

export const getTagList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/tag/page'
  })
}

export const getTagGroups = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/tag/groups'
  })
}

export const addTag = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/tag'
  })
}

export const editTag = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/tag'
  })
}

export const delTag = (id) => {
  return axios.request({
    method: 'delete',
    url: '/tag/' + id
  })
}

export const getTagInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/tag/' + id
  })
}

export const changeTagStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/tag/status/' + id
  })
}
